import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/pages/blog/components/PostCard";
import { GUIDE_LEVELS, getRecentPosts } from "@/pages/blog/blogData";

const FILTERS = ["Todos", ...GUIDE_LEVELS];

export default function GuidesSection() {
  const [level, setLevel] = useState("Todos");
  const allGuides = useMemo(() => getRecentPosts(), []);

  const guides = useMemo(() => {
    if (level === "Todos") return allGuides;
    return allGuides.filter((post) => post.level === level);
  }, [level, allGuides]);

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Guias e Tutoriais"
          badgeIcon="ri-guide-line"
          title="Guias e Tutoriais"
          description="Tutoriais passo a passo para resolver problemas, configurar serviços e aprender tecnologia de forma prática."
        />

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {FILTERS.map((filter) => {
            const active = filter === level;
            return (
              <button
                key={filter}
                type="button"
                onClick={() => setLevel(filter)}
                aria-pressed={active}
                className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${
                  active
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {filter}
              </button>
            );
          })}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {guides.slice(0, 6).map((post, index) => (
            <Reveal key={post.slug} delay={index * 40}>
              <PostCard post={post} />
            </Reveal>
          ))}
        </div>

        {guides.length === 0 ? (
          <p className="mt-10 text-center text-sm text-foreground-500">
            Nenhum tutorial neste nível por enquanto. Escolha outro filtro para ver mais conteúdos.
          </p>
        ) : null}

        <div className="mt-10 text-center">
          <Link
            to="/blog/guias-tutoriais"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-book-2-line" aria-hidden="true"></i>
            Ver todos os guias e tutoriais
          </Link>
        </div>
      </div>
    </section>
  );
}